export default "__VITE_ASSET__DO3q9jWT__"